
import React from 'react';
import { BrowserRouter as Router, Routes, Route} from "react-router-dom";
import './App.css';
// import AnimatedCursor from "react-animated-cursor"
import Home from './pages/web/home';
import NotFound from './pages/components/NotFound';
import { Toaster } from 'react-hot-toast';

import GameListPage from './pages/GameListPage';
import GameDetailsPage from './pages/GameDetailsPage';
import GamePlan from './pages/GamePlan';
import TransactionHistoryPage from './pages/TransactionHistoryPage';
import Privacy from './pages/web/Privacy';
import Terms from './pages/web/Terms';
import Delete from './pages/web/Delete';
import NeedHelp from './pages/web/NeedHelp';
import Game from './pages/Game';
import ScrollToTop from './pages/components/ScrollToTop';


function App() {

  return (
    <>
    <Toaster position="top-right" />
      <Router>
        <ScrollToTop />
        <Routes>
            <Route path="/game" element={<Game />} />
            <Route path="/game-list" element={<GameListPage />} />
            <Route path="/games/:id" element={<GameDetailsPage />} />
            <Route path="/game-plan/:gameId" element={<GamePlan />} />
            <Route path="/transaction-history" element={<TransactionHistoryPage />} />
            <Route path="*" element={<NotFound />} />

            <Route path="/" element={<Home />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/delete" element={<Delete />} />
            <Route path="/need-help" element={<NeedHelp />} />
        </Routes>
      </Router>
            
    {/* <AnimatedCursor 
      innerSize={10}
      outerSize={20}
      color='70, 70, 229'
      outerAlpha={0.2}
      innerScale={1}
      outerScale={5}
    /> */}
    </>
  );
}

export default App;
